import React, { createContext, useState } from 'react';

const FIRContext = createContext(null);

function FIRContextProvider(props) {
  const [fir, setFIR] = useState(null);

  const setAndStoreFir = (newValues) => {
    setFIR(newValues);
    localStorage.setItem('current_fir', JSON.stringify(newValues));
  };

  return (
    <FIRContext.Provider
      value={{
        fir: fir || JSON.parse(localStorage.getItem('current_fir')),
        setFIR: setAndStoreFir,
      }}
    >
      {props.children}
    </FIRContext.Provider>
  );
}

export { FIRContextProvider, FIRContext };
